import * as R from 'ramda'

import i18n from '../locales/i18n'
import { FallbackLanguageCode, LanguageCodes } from '../localization'
import { AddressParams, Nil } from '../types'

const RegionOrderedAddressKeysMap = {
  US: ['address', 'city', 'state', 'zip', 'country'],
  EU: ['address', 'zip', 'city', 'state', 'country'],
}

export const LocaleOrderedAddressKeysMap = {
  [LanguageCodes['en-US']]: RegionOrderedAddressKeysMap.US,
  [LanguageCodes['ca-ES']]: RegionOrderedAddressKeysMap.EU,
  [LanguageCodes['es-ES']]: RegionOrderedAddressKeysMap.EU,
  [LanguageCodes['pt-BR']]: RegionOrderedAddressKeysMap.EU,
  [LanguageCodes['pt-PT']]: RegionOrderedAddressKeysMap.EU,
}

export const getLocaleOrderedAddressList = (addressParams: AddressParams) => {
  const localeOrderedAddressKeys =
    LocaleOrderedAddressKeysMap[i18n.language] ||
    LocaleOrderedAddressKeysMap[FallbackLanguageCode]

  return Object.values(
    R.pick(localeOrderedAddressKeys, R.filter(Boolean, addressParams)),
  )
}

export const formatAddress = (
  params: AddressParams | Nil,
  withNewLine?: boolean,
) => {
  const { address, suite, city, state, zip: zipProp, zipcode } = params || {}
  const suitePart = suite ? ` ${suite}` : ''
  const newLine = withNewLine ? '\n' : ' '
  const addressSuitePart =
    address || suitePart ? `${address}${suitePart},${newLine}` : ''
  const restPart = getLocaleOrderedAddressList({
    city,
    state,
    zip: zipProp || zipcode,
  }).join(', ')

  return addressSuitePart + restPart
}
